import abstractModel from '../../core/MercatelyModel';
import { MERCATELY_API } from '../../constants/AppConstants';

const resource = `${MERCATELY_API}/retailer_users`;
const resourceActives = `${resource}/actives`;
const resourceByRole = `${resource}/by_role`;

const model = abstractModel(resource);

// Get active retailer users
model.getActiveRetailerUsers = async (params) =>
  model.get(params, { path: resourceActives });

// Get active retailer users by role
model.getActiveRetailerUsersByRole = async (params) =>
  model.get(params, { path: resourceByRole });

export default model;